// extracted by mini-css-extract-plugin
export default {"student-field":"AddStudentRow_student-field__C2RmV"};